
import { Link } from "react-router-dom";
import { DescriptionBox } from "./DescriptionBox";

/**
 * ダウンロードとインストールの指示を表示
 * @param {string} downloadLink - ダウンロードページのリンク
 * @param {string} driverLink - デバイスドライバーインストールページのリンク
 */

interface DownloadInstructionsProps {
	downloadLink: string;
	driverLink: string;
}

export const DownloadInstructions: React.FC<DownloadInstructionsProps> = ({ 
	downloadLink, 
	driverLink 
}) => (
	<DescriptionBox description = {
		<>
			ソフトウェアのダウンロードがお済みでない方は、
			<Link to={downloadLink}>ダウンロード方法</Link>
			を参考にして、ソフトウェアをダウンロードしてください。
			<br />
			ドライバーソフトウェアのインストールがお済みでない方は、
			<Link to={driverLink}>デバイスドライバーのインストール方法</Link>
			を参考にして、デバイスドライバーソフトウェアをインストールしてください。
		</>
	} />
);


